export const playlistCoverButtonDataSet = { cy: 'change-playlist-cover-button' };
